import { jsx as r } from "react/jsx-runtime";
import { Icon as t } from "./Icon.js";
const i = (o) => /* @__PURE__ */ r(t, { ...o, children: /* @__PURE__ */ r(
  "path",
  {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M6 14.6663V1.33301M6 1.33301L1 6.33301M6 1.33301L11 6.33301",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
) });
export {
  i as UpArrow
};
